<div>
  @for (stage of stages(); track stage.id) {
    <mat-chip>{{ stage.label }}</mat-chip>
  }
</div>
